import React, { FC, useState } from 'react';

import { FeedArea } from '@go-shared/types/feedTemplate';
import { BubbleButton, BubbleInput } from '../BubbleUI';
import { Alert } from '@spark-labs/avocado-ui';

interface Props {
  feedArea: FeedArea;
  onMultiDayConfigUpdated: ({
    feedArea,
    startDate,
    endDate,
  }: {
    feedArea: FeedArea;
    startDate: string;
    endDate: string;
  }) => void;
}

export const MultiDaySettings: FC<Props> = ({ feedArea, onMultiDayConfigUpdated }) => {
  const [startDate, setStartDate] = useState(feedArea.params?.multiDayConfig?.startDate || '');
  const [endDate, setEndDate] = useState(feedArea.params?.multiDayConfig?.endDate || '');

  function isSyncButtonEnabled() {
    if (!startDate || !endDate) {
      return false;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    return end > start;
  }

  return (
    <React.Fragment>
      <div className="flex my-4">
        <div className="mx-4">
          <span>Start Date</span>
          <BubbleInput
            type="date"
            block
            value={startDate}
            onValue={date => {
              setStartDate(date);
            }}
          />
        </div>
        <div className="mx-4">
          <span>End Date</span>
          <BubbleInput
            type="date"
            block
            value={endDate}
            onValue={date => {
              const start = new Date(startDate);
              const end = new Date(date);

              if (end <= start) {
                Alert.error('End date must be after the start date');
              }

              setEndDate(date);
            }}
          />
        </div>
      </div>
      <BubbleButton
        variant="navy"
        className="m-4"
        disabled={!isSyncButtonEnabled()}
        onClick={() => {
          onMultiDayConfigUpdated({
            feedArea,
            startDate,
            endDate,
          });
        }}
        icon="rotate"
      >
        Sync Changes to Feed
      </BubbleButton>
    </React.Fragment>
  );
};
